var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 17.5,
    stroke: "#2D2926"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 24.0001C16 24.6026 16.4884 25.091 17.0909 25.091L25.0909 25.091L30.9091 25.091C31.5116 25.091 32 24.6026 32 24.0001C32 23.3976 31.5116 22.9092 30.9091 22.9092H25.0909H17.0909C16.4884 22.9092 16 23.3976 16 24.0001Z",
    fill: "#2D2926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.5065dd7ac4c5c884bae3919d8d342307.svg";
export { ForwardRef as ReactComponent };